module.exports = __webpack_public_path__ + "img/asset_thumb_placeholder.bbc7ee8a.jpg";